import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isProductsOpen, setIsProductsOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const brands = [
    { name: 'Tinergy', path: '/products/tinergy' },
    { name: 'Titax', path: '/products/titax' },
    { name: 'Albalux', path: '/products/albalux' }
  ];

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_tioxide-hub/artifacts/50u4k8b4_Trustar%20Logo%20H.png" 
              alt="Trustar Industrial Chemicals" 
              className="h-12"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <Link
              to="/"
              className="text-gray-700 hover:text-primary font-medium transition-colors"
            >
              Home
            </Link>
            
            <Link
              to="/about"
              className="text-gray-700 hover:text-primary font-medium transition-colors"
            >
              About Us
            </Link>

            {/* Products Dropdown */}
            <div 
              className="relative"
              onMouseEnter={() => setIsProductsOpen(true)}
              onMouseLeave={() => setIsProductsOpen(false)}
            >
              <button className="flex items-center text-gray-700 hover:text-primary font-medium transition-colors py-2">
                Products
                <ChevronDown size={16} className={`ml-1 transition-transform ${isProductsOpen ? 'rotate-180' : ''}`} />
              </button>
              
              {isProductsOpen && (
                <div className="absolute top-full left-0 pt-2 w-56">
                  <div className="bg-white rounded-lg shadow-xl border border-gray-100 py-2">
                    {brands.map((brand) => (
                      <Link
                        key={brand.path}
                        to={brand.path}
                        className="block px-4 py-3 text-gray-700 hover:bg-blue-50 hover:text-primary transition-colors"
                        onClick={() => setIsProductsOpen(false)}
                      >
                        {brand.name}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <Link
              to="/partner-with-us"
              className="text-gray-700 hover:text-primary font-medium transition-colors"
            >
              Partner With Us
            </Link>

            <Link
              to="/contact"
              className="text-gray-700 hover:text-primary font-medium transition-colors"
            >
              Contact Us
            </Link>

            <Link to="/contact">
              <Button size="sm" className="ml-4">
                Request A Quote
              </Button>
            </Link>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2"
          >
            <div className="w-6 h-5 flex flex-col justify-between">
              <span className={`w-full h-0.5 bg-gray-700 transition-all ${isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
              <span className={`w-full h-0.5 bg-gray-700 transition-all ${isMobileMenuOpen ? 'opacity-0' : ''}`}></span>
              <span className={`w-full h-0.5 bg-gray-700 transition-all ${isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
            </div>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="lg:hidden py-4 border-t">
            <Link
              to="/"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-3 text-gray-700 hover:bg-gray-50 font-medium"
            >
              Home
            </Link>
            <Link
              to="/about"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-3 text-gray-700 hover:bg-gray-50 font-medium"
            >
              About Us
            </Link>
            
            <div className="px-4 py-2">
              <p className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">Products</p>
              {brands.map((brand) => (
                <Link
                  key={brand.path}
                  to={brand.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block px-4 py-2 text-gray-700 hover:bg-gray-50"
                >
                  {brand.name}
                </Link>
              ))}
            </div>

            <Link
              to="/partner-with-us"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-3 text-gray-700 hover:bg-gray-50 font-medium"
            >
              Partner With Us
            </Link>

            <Link
              to="/contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-3 text-gray-700 hover:bg-gray-50 font-medium"
            >
              Contact Us
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
